import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTemplatesBlockerUseGet = {
    path: "/templates/blocker/:identifier",
    method: RouteHttpVerb.GET,
    obfuscatePath: "full"
};
export { locationRestTemplatesBlockerUseGet };
